import { getDevice } from "./getdevice";
import { Project } from "./project";

export class Objects {
    name: string;
    displayName: string;
    unit: string;
    order: string;
    correcttodecimalplace: string;
    getdevice: getDevice;
      }
 

    //   communicationstartswith: string;
    // valueseprator: string;
    // recordseprator: string;
    // communicationendswith: string;